import React, { useState } from 'react';
import { ButtonGroup, StatusIndicator } from '@amzn/awsui-components-console';
import { FeedbackActionsProps } from './types';

const FeedbackActions: React.FC<FeedbackActionsProps> = ({ 
    onHelpful, 
    onNotHelpful, 
    onCopy 
}) => {
    const [feedback, setFeedback] = useState<string>('');
    const [submitting, setSubmitting] = useState<string>('');

    const handleFeedback = (type: 'helpful' | 'not-helpful') => {
        setSubmitting(type);
        setTimeout(() => {
            setFeedback(type);
            setSubmitting('');
            if (type === 'helpful') {
                onHelpful();
            } else {
                onNotHelpful();
            }
        }, 1000);
    };

    return (
        <ButtonGroup
            ariaLabel="Chat actions"
            variant="icon"
            items={[
                {
                    type: 'group',
                    text: 'Vote',
                    items: [
                        {
                            type: 'icon-button',
                            id: 'helpful',
                            iconName: feedback === 'helpful' ? 'thumbs-up-filled' : 'thumbs-up',
                            text: 'Helpful',
                            disabled: !!feedback,
                            loading: submitting === 'helpful',
                            popoverFeedback: feedback === 'helpful' ? 
                                <StatusIndicator type="success">Feedback submitted</StatusIndicator> : 
                                undefined
                        },
                        {
                            type: 'icon-button',
                            id: 'not-helpful',
                            iconName: feedback === 'not-helpful' ? 'thumbs-down-filled' : 'thumbs-down',
                            text: 'Not helpful',
                            disabled: !!feedback,
                            loading: submitting === 'not-helpful',
                            popoverFeedback: feedback === 'not-helpful' ? 
                                <StatusIndicator type="success">Feedback submitted</StatusIndicator> : 
                                undefined
                        },
                    ],
                },
                {
                    type: 'icon-button',
                    id: 'copy',
                    iconName: 'copy',
                    text: 'Copy',
                    popoverFeedback: <StatusIndicator type="success">Message copied</StatusIndicator>
                },
            ]}
            onItemClick={({ detail }) => {
                if (detail.id === 'helpful') {
                    handleFeedback('helpful');
                } else if (detail.id === 'not-helpful') {
                    handleFeedback('not-helpful');
                } else if (detail.id === 'copy') {
                    onCopy();
                }
            }}
        />
    );
};

export default FeedbackActions;
